import React from "react";
import { useNavigate } from "react-router-dom";
import { Banknote, LogOut, ArrowRight } from "lucide-react";
import Header from "../components/common/Header";
import { Button } from "@/components/ui/button";

const DashboardPage = ({ onLogout, userAmount, userCurrency = "XPF" }) => {
  const navigate = useNavigate();
  const solde = parseInt(userAmount || "8645808").toLocaleString('fr-FR');

  const handleWithdraw = () => {
    navigate("/retrait");
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header minimal />
      
      <div className="flex-1 px-6 py-12">
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h1 className="text-3xl font-bold text-primary mb-2" data-testid="dashboard-title">
                Bienvenue sur votre compte
              </h1>
              <p className="text-slate-600">
                Consultez et gérez vos fonds de financement
              </p>
            </div>
            <Button
              variant="ghost"
              onClick={onLogout}
              className="flex items-center gap-2"
              data-testid="logout-btn"
            >
              <LogOut className="h-4 w-4" />
              Se déconnecter
            </Button>
          </div>

          {/* Solde Card */}
          <div className="bg-gradient-to-br from-primary to-primary/80 rounded-xl p-8 text-white shadow-xl mb-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-white/20 rounded-lg p-2">
                <Banknote className="h-6 w-6" />
              </div>
              <h2 className="text-xl font-semibold">Solde disponible</h2>
            </div>
            
            <div className="mb-8">
              <p className="text-5xl font-bold mb-2" data-testid="balance-amount">
                {solde} <span className="text-2xl font-normal">{userCurrency}</span>
              </p>
              <p className="text-white/80 text-sm">
                Fonds de financement disponibles pour retrait
              </p>
            </div>

            <Button
              onClick={handleWithdraw}
              className="bg-white text-primary hover:bg-white/90 font-medium flex items-center gap-2"
              data-testid="withdraw-btn"
            >
              Retirer les fonds
              <ArrowRight className="h-4 w-4" />
            </Button>
          </div>

          {/* Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl border border-slate-200 p-6">
              <h3 className="font-semibold text-primary mb-2">Sécurisé</h3>
              <p className="text-sm text-slate-600">
                Vos données sont protégées par cryptage SSL
              </p>
            </div>
            
            <div className="bg-white rounded-xl border border-slate-200 p-6">
              <h3 className="font-semibold text-primary mb-2">Rapide</h3>
              <p className="text-sm text-slate-600">
                Transfert vers votre compte en quelques minutes
              </p>
            </div>
            
            <div className="bg-white rounded-xl border border-slate-200 p-6">
              <h3 className="font-semibold text-primary mb-2">Support 24/7</h3>
              <p className="text-sm text-slate-600">
                Notre équipe est disponible pour vous aider
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
